import { c as _c } from "react/compiler-runtime";
import { useRollbar } from '@rollbar/react';
import { useEffect } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { useRouter } from 'shared/hooks/use-router';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { UserInterface } from 'shared/types/user-interface';
import useSWR, { useSWRConfig } from 'swr';
import { DASHBOARD_USER_DATA_API, PUBLIC_USER_DATA_API } from '../constants/api';
import { publicRoutes } from '../constants/public-routes';
import { isAuthorized } from '../utils/is-authorized';
export const useDashboardUser = () => {
  const $ = _c(22);
  const {
    pathname
  } = useRouter();
  const rollbar = useRollbar();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get,
      stopErrorPropagation: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    cache
  } = useSWRConfig();
  let isDashboard;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] !== cache || $[2] !== fetcher || $[3] !== pathname) {
    const publicUser = cache.get(PUBLIC_USER_DATA_API)?.data;
    let t5;
    if ($[9] !== pathname) {
      t5 = publicRoutes.some(route => pathname.includes(route));
      $[9] = pathname;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    isDashboard = !t5;
    t2 = useSWR;
    t3 = isDashboard && DASHBOARD_USER_DATA_API;
    t4 = fetcher;
    t1 = publicUser && isAuthorized(publicUser) ? publicUser : undefined;
    $[1] = cache;
    $[2] = fetcher;
    $[3] = pathname;
    $[4] = isDashboard;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    isDashboard = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[11] !== t1) {
    t5 = {
      fallbackData: t1
    };
    $[11] = t1;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    data: dashboardUser,
    mutate: dashboardMutate
  } = t2(t3, t4, t5);
  let t6;
  let t7;
  if ($[13] !== dashboardUser || $[14] !== isDashboard || $[15] !== rollbar) {
    t6 = () => {
      if (dashboardUser && isDashboard) {
        rollbar.configure({
          payload: {
            person: {
              id: dashboardUser.id,
              username: `${dashboardUser.firstName} ${dashboardUser.lastName}`
            }
          }
        });
      }
    };
    t7 = [dashboardUser, rollbar, isDashboard];
    $[13] = dashboardUser;
    $[14] = isDashboard;
    $[15] = rollbar;
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  useEffect(t6, t7);
  const isDisabled = dashboardUser ? !dashboardUser.impersonator && !dashboardUser.enabled : false;
  let t8;
  if ($[18] !== dashboardMutate || $[19] !== dashboardUser || $[20] !== isDisabled) {
    t8 = {
      dashboardUser,
      dashboardMutate,
      isDisabled
    };
    $[18] = dashboardMutate;
    $[19] = dashboardUser;
    $[20] = isDisabled;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};